// extracted by mini-css-extract-plugin
export default {"customSocialMediaBtn":"GoogleButton_customSocialMediaBtn__19ayl","icon":"GoogleButton_icon__wf-o8","text":"GoogleButton_text__cGrn6"};